<template>
  <PortfolioNavbar />
  <section class="py-24 bg-purple-100">
    <PortfolioHeading>{{ pageTitle }}</PortfolioHeading>
    <BrowserArtboard :url="artBoardUrl" :image="artBoardImage" class="max-w-6xl mx-auto px-8" />
    <div class="flex flex-col lg:flex-row w-full justify-between px-8 gap-16 max-w-6xl mx-auto">
      <div class="max-w-3xl">
        <slot name="info-content"></slot>
      </div>
      <div class="lg:max-w-96 flex-grow flex-shrink-0">
        <div class="bg-neutral rounded-xl shadow-lg p-8 w-full">
          <h3 class="text-2xl text-balance font-bold tracking-tight text-gray-300 mb-4">Leveled Up</h3>
          <slot name="level-up-content"></slot>
        </div>
      </div>
    </div>
    <BackButton class="mt-14"/>
  </section>
  <FooterBase class-names="-mt-2"/>
</template>

<script>
import PortfolioNavbar from "@/components/PortfolioNavbar.vue";
import BackButton from "@/components/BackButton.vue";
import BrowserArtboard from "@/components/BrowserArtboard.vue";
import PortfolioHeading from "@/components/PortfolioHeading.vue";
import FooterBase from "@/components/FooterBase.vue";

export default {
  props: {
    pageTitle: {
      type: String,
      required: true,
    },
    artBoardUrl: {
      type: String,
      required: true,
    },
    artBoardImage: {
      type: String,
      required: true,
    }
  },
  components: {
    FooterBase,
    PortfolioHeading,
    BrowserArtboard,
    BackButton,
    PortfolioNavbar
  }
}
</script>
